import { type JSX } from "react";

import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import { Box, Stack, Typography } from "@mui/material";
import { type AlertColor } from "@mui/material/Alert";

type Props = {
  icon?: JSX.Element;
  severity?: AlertColor;
  title?: string;
  description?: JSX.Element | string;
  children?: JSX.Element;
};

export function CenteredMessage({ icon, title, description, children, severity }: Props) {
  const getSeverityIcon = () => {
    if (icon) return icon;

    switch (severity) {
      case "error":
        return <ErrorOutlineIcon sx={{ fontSize: 48 }} color="error" />;
      case "warning":
        return <WarningAmberIcon sx={{ fontSize: 48 }} color="warning" />;
      case "info":
        return <InfoOutlinedIcon sx={{ fontSize: 48 }} color="info" />;
      case "success":
        return <CheckCircleOutlineIcon sx={{ fontSize: 48 }} color="success" />;
      default:
        return null;
    }
  };

  const severityIcon = getSeverityIcon();

  return (
    <Stack
      sx={{
        alignItems: "center",
        pt: 20,
        pb: 5,
      }}
      spacing={2}
    >
      {severityIcon && <Box>{severityIcon}</Box>}

      {title && (
        <Typography variant="subtitle1" textAlign="center">
          {title}
        </Typography>
      )}

      {description && (
        <Typography sx={{ textAlign: "center", maxWidth: 600 }} variant="body2" textAlign="center">
          {description}
        </Typography>
      )}
      <Box sx={{ pt: 2 }}>{children}</Box>
    </Stack>
  );
}
